var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoMonitoramentoFornecedores01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "global-connection",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_953",
    d: "M14,13.4c-0.9,0-1.7,0.8-1.7,1.7c0,0.9,0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7 C15.7,14.2,14.9,13.4,14,13.4z M14,15.7c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6 C14.6,15.4,14.3,15.7,14,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_954",
    d: "M11.2,12.3l0.8,0.8c1.1-1.1,2.9-1.1,4,0l0.8-0.8C15.2,10.8,12.8,10.8,11.2,12.3 C11.2,12.3,11.2,12.3,11.2,12.3L11.2,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_955",
    d: "M29.2,14c0-6.3-3.9-11.9-9.7-14.2c-1.6-3-5.4-4.1-8.4-2.5c-1.1,0.6-2,1.5-2.5,2.5 c-7.8,3-11.7,11.8-8.7,19.6c1.5,4,4.7,7.2,8.7,8.7c1.6,3,5.4,4.1,8.4,2.5c1.1-0.6,2-1.5,2.5-2.5C25.3,25.9,29.2,20.3,29.2,14z  M20,26.7c0.4-1.4,0.2-3-0.5-4.3h5.7C23.9,24.3,22.1,25.7,20,26.7z M15.9,26.2c1.1-1,1.2-2.8,0.2-4c-1-1.1-2.8-1.2-4-0.2 s-1.2,2.8-0.2,4c0.1,0.1,0.1,0.1,0.2,0.2c-0.9,0.4-1.7,1-2.3,1.9c-1.6-2.3-0.9-5.5,1.4-7s5.5-0.9,7,1.4c1.1,1.7,1.1,3.9,0,5.6 C17.6,27.2,16.8,26.6,15.9,26.2L15.9,26.2z M12.3,24.1c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7 C13.1,25.8,12.3,25,12.3,24.1L12.3,24.1z M0,14.6h7.9c0.2,2.2,1.6,4.1,3.6,5.1c-0.9,0.4-1.6,1-2.2,1.7H2C0.8,19.3,0.1,16.9,0,14.6 L0,14.6z M12.3,1.6c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7S14.9,3.3,14,3.3l0,0C13.1,3.3,12.3,2.6,12.3,1.6z M28,13.4h-7.9 c-0.2-2.2-1.6-4.1-3.6-5.1c0.9-0.4,1.6-1,2.2-1.7H26C27.2,8.7,27.9,11.1,28,13.4z M16.6,19.6c2-0.9,3.4-2.8,3.6-5.1H28 c-0.1,2.4-0.8,4.7-2,6.7h-7.2C18.2,20.6,17.4,20,16.6,19.6L16.6,19.6z M14,19.1c-2.8,0-5.1-2.3-5.1-5.1s2.3-5.1,5.1-5.1 c2.8,0,5.1,2.3,5.1,5.1C19.1,16.8,16.8,19.1,14,19.1L14,19.1z M14,7.8c-1.3,0-2.5-0.5-3.4-1.3c1-1.9,3.4-2.6,5.3-1.5 c0.6,0.4,1.2,0.9,1.5,1.5C16.5,7.3,15.3,7.8,14,7.8L14,7.8z M11.4,8.4c-2,0.9-3.4,2.8-3.6,5.1H0c0.1-2.4,0.8-4.7,2-6.7h7.2 C9.8,7.4,10.6,8,11.4,8.4L11.4,8.4z M25.2,5.6h-5.7c0.7-1.3,0.9-2.8,0.5-4.3C22.1,2.3,23.9,3.7,25.2,5.6z M14-2.3 c2.8,0,5.1,2.3,5.1,5c0,1-0.3,2-0.9,2.8c-0.6-0.8-1.4-1.5-2.3-1.9c1.1-1,1.2-2.8,0.2-4s-2.8-1.2-4-0.2s-1.2,2.8-0.2,4 C12,3.6,12,3.6,12.1,3.7c-0.9,0.4-1.7,1-2.3,1.9c-1.6-2.3-0.9-5.5,1.4-7C12-2,13-2.3,14-2.3L14-2.3z M8,1.3c-0.4,1.4-0.2,3,0.5,4.3 H2.8C4.1,3.7,5.9,2.3,8,1.3z M2.8,22.4h5.7c-0.7,1.3-0.9,2.8-0.5,4.3C5.9,25.7,4.2,24.3,2.8,22.4L2.8,22.4z M10.6,29 c1-1.9,3.4-2.6,5.3-1.5c0.6,0.4,1.2,0.9,1.5,1.5C15.5,30.7,12.5,30.7,10.6,29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_956",
    d: "M2.2,3.3c0-0.6,0.5-1.1,1.1-1.1V1.1c-1.2,0-2.2,1-2.2,2.2H2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_957",
    d: "M3.3-1.2c-2.5,0-4.5,2-4.5,4.5h1.1C0,1.5,1.5,0,3.3-0.1V-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_958",
    d: "M3.3-2.3v-1.1c-3.7,0-6.7,3-6.7,6.7h1.1C-2.3,0.2,0.2-2.3,3.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_959",
    d: "M2.2,24.7H1.1c0,1.2,1,2.2,2.2,2.2v-1.1C2.7,25.8,2.2,25.3,2.2,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_960",
    d: "M-0.1,24.7h-1.1c0,2.5,2,4.5,4.5,4.5v-1.1C1.5,28,0,26.5-0.1,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_961",
    d: "M-2.3,24.7h-1.1c0,3.7,3,6.7,6.7,6.7v-1.1C0.2,30.3-2.3,27.8-2.3,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_962",
    d: "M25.8,24.7c0,0.6-0.5,1.1-1.1,1.1v1.1c1.2,0,2.2-1,2.2-2.2H25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_963",
    d: "M24.7,29.2c2.5,0,4.5-2,4.5-4.5h-1.1c0,1.9-1.5,3.4-3.4,3.4V29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_964",
    d: "M24.7,30.3v1.1c3.7,0,6.7-3,6.7-6.7h-1.1C30.3,27.8,27.8,30.3,24.7,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_965",
    d: "M25.8,3.3h1.1c0-1.2-1-2.2-2.2-2.2v1.1C25.3,2.2,25.8,2.7,25.8,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_966",
    d: "M28.1,3.3h1.1c0-2.5-2-4.5-4.5-4.5v1.1C26.5,0,28,1.5,28.1,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_967",
    d: "M30.3,3.3h1.1c0-3.7-3-6.7-6.7-6.7v1.1C27.8-2.3,30.3,0.2,30.3,3.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMonitoramentoFornecedores01);
export default __webpack_public_path__ + "static/media/ico-monitoramento-fornecedores-01.f37d9e6046ab8e90f2d9697f85ca3169.svg";
export { ForwardRef as ReactComponent };